import { Dropdown, ColourPicker, MultiSelectionList, ReorderArray, QueueSelect, Popup, FilterMenu, ControlBase } from "./components";

const GlobalComponents = {
  install(Vue) {
    Vue.component("drop-down", Dropdown);
    Vue.component("colour-picker", ColourPicker);
    Vue.component("multi-selection-list", MultiSelectionList);
    Vue.component("reorder-array", ReorderArray);
    Vue.component("queue-select", QueueSelect);
    Vue.component("popup", Popup);
    Vue.component("filter-menu", FilterMenu);
    Vue.component("control-base", ControlBase);
  }
};

export default GlobalComponents;